if (!customElements.get('product-sticky-cart')) {
  class ProductStickyCart extends HTMLElement {
    constructor() {
      super();

      this.setHeightCSSVariableRef = this.setHeightCSSVariable.bind(this);
    }

    setHeightCSSVariable() {
      document.documentElement.style.setProperty('--sticky-atc-height', this.scrollHeight + 'px');
    }

    disconnectedCallback() {
      window.removeEventListener('scroll', this.setHeightCSSVariableRef);
    }

    connectedCallback() {
      this.setHeightCSSVariable();

      window.addEventListener('resize', this.setHeightCSSVariableRef, false);
    }
  }

  customElements.define('product-sticky-cart', ProductStickyCart);
}
